import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

export const TranscriptScrollButton = ({ onSetUserScrolled }: { onSetUserScrolled: (value: boolean) => void }) => {
  const { t } = useTranslation('components', { keyPrefix: 'transcript' });

  return (
    <Typography
      variant="text2"
      onClick={() => onSetUserScrolled(false)}
      sx={{
        color: 'primary.main',
        '&:hover': {
          color: 'primary.light',
          cursor: 'pointer',
        },
      }}
    >
      {t('scrollButton')}
    </Typography>
  );
};
